import React from 'react'
import * as components from './components'
import * as stores from './stores/appStore'

function App() {
  const { people, viewMode, setViewMode } = stores.useAppStore()
  const [isAddPersonModalOpen, setIsAddPersonModalOpen] = React.useState(false)
  const [showSettings, setShowSettings] = React.useState(false)

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="border-b border-border bg-card">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <svg className="w-6 h-6 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg>
            <h1 className="text-xl font-semibold">BookEveryone</h1>
          </div>
          <div className="flex items-center space-x-4">
            {!showSettings && (
              <div className="flex items-center bg-background rounded-lg p-1">
                <button
                  onClick={() => setViewMode('list')}
                  className={`px-3 py-1 rounded ${
                    viewMode === 'list'
                      ? 'bg-primary-600 text-white'
                      : 'text-foreground hover:bg-gray-100'
                  }`}
                >
                  List
                </button>
                <button
                  onClick={() => setViewMode('calendar')}
                  className={`px-3 py-1 rounded ${
                    viewMode === 'calendar'
                      ? 'bg-primary-600 text-white'
                      : 'text-foreground hover:bg-gray-100'
                  }`}
                >
                  Calendar
                </button>
              </div>
            )}
            <button
              onClick={() => setShowSettings(!showSettings)}
              className={`p-2 hover:bg-gray-100 rounded ${showSettings ? 'bg-gray-100' : ''}`}
              title="Settings"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto px-4 py-8">
        {showSettings ? (
          <components.Settings />
        ) : people.length === 0 ? (
          // Empty State
          <div className="max-w-md mx-auto text-center py-16">
            <div className="mb-8">
              <svg className="w-24 h-24 mx-auto text-primary-600 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
              <h2 className="text-2xl font-bold mb-2">Welcome to BookEveryone</h2>
              <p className="text-gray-600 mb-6">
                Aggregate everyone's availability in one beautiful place
              </p>
              <button
                onClick={() => setIsAddPersonModalOpen(true)}
                className="inline-flex items-center px-6 py-3 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
              >
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                </svg>
                Add Person
              </button>
              <p className="mt-8 text-sm text-gray-500">
                Your data never leaves your browser
              </p>
            </div>
          </div>
        ) : (
          // Content based on view mode
          viewMode === 'list' ? (
            <components.ListView />
          ) : (
            <components.CalendarView />
          )
        )}
      </main>

      {/* Add Person Modal */}
      {isAddPersonModalOpen && (
        <components.AddPersonModal
          isOpen={isAddPersonModalOpen}
          onClose={() => setIsAddPersonModalOpen(false)}
        />
      )}
    </div>
  )
}

export default App